import {createSlice} from '@reduxjs/toolkit';
import {DEFAULT_TOAST_VISIBILITY_TIME} from '../../constants';
import {State} from './types';

const initialState: State = {
    toast: {
        isVisible: false,
        content: null,
        visibilityTime: DEFAULT_TOAST_VISIBILITY_TIME
    },
    popup: {},
    loader: {
        isLoader: false,
        loadingCount: 0
    },
    serverErrorStatus: null,
    wizard: {activeStep: 0},
    isBrowserTabActive: true,
    isOnline: true
};

const slice = createSlice({
    name: 'shared',
    initialState,
    reducers: {
        showToast(state, action) {
            const {content, visibilityTime = DEFAULT_TOAST_VISIBILITY_TIME} = action.payload;
            state.toast = {isVisible: true, content, visibilityTime};
        },
        hideToast(state) {
            state.toast = {isVisible: false, content: null, visibilityTime: DEFAULT_TOAST_VISIBILITY_TIME};
        },
        openPopup(state, action) {
            const {id, type, isOnlyManualClose, ...rest} = action.payload;
            state.popup[id] = {isOpened: true, id, type, isOnlyManualClose, ...rest};
        },
        closePopup(state, action) {
            const {id} = action.payload;
            state.popup[id] = {};
        },
        startLoading(state) {
            state.loader.loadingCount += 1;
            state.loader.isLoader = true;
        },
        finishLoading(state) {
            state.loader.loadingCount -= 1;
            state.loader.isLoader = state.loader.isLoader && !!state.loader.loadingCount;
        },
        setWizardActiveStep(state, action) {
            state.wizard = {activeStep: action.payload};
        },
        goNextWizardStep(state) {
            const activeStep = state.wizard.activeStep + 1;
            state.wizard = {activeStep};
        },
        goPrevWizardStep(state) {
            const activeStep = state.wizard.activeStep - 1;
            state.wizard = {activeStep};
        },
        setServerErrorStatus(state, action) {
            state.serverErrorStatus = action.payload;
        },
        setIsBrowserTabActive(state, action) {
            state.isBrowserTabActive = action.payload;
        },
        setIsOnline(state, action) {
            state.isOnline = action.payload;
        }
    },
    selectors: {
        getToastState: state => state.toast,
        getPopupState: state => state.popup,
        getLoaderStatus: state => state.loader.isLoader,
        getWizardActiveStep: state => state.wizard.activeStep,
        getServerErrorStatus: state => state.serverErrorStatus,
        getIsBrowserTabActive: state => state.isBrowserTabActive,
        getIsOnline: state => state.isOnline
    }
});

export const {
    showToast,
    hideToast,
    openPopup,
    closePopup,
    startLoading,
    finishLoading,
    setWizardActiveStep,
    goNextWizardStep,
    goPrevWizardStep,
    setServerErrorStatus,
    setIsBrowserTabActive,
    setIsOnline
} = slice.actions;
export const {
    getToastState,
    getPopupState,
    getLoaderStatus,
    getWizardActiveStep,
    getServerErrorStatus,
    getIsBrowserTabActive,
    getIsOnline
} = slice.selectors;
export default slice.reducer;
